<template>
  <div class="descriptive-text">
    <el-form-item label="标题">
      <el-input v-model="activeData.config.label" placeholder="请输入标题" />
    </el-form-item>
    <el-divider>描述文本</el-divider>
    <div style="width: 304px">
      <dt-tinymce v-model="activeData.content" />
    </div>
  </div>
</template>

<script>
import DtTinymce from '@/components/DtTinymce/index.vue'
export default {
  name: 'ConfigItemDescText',
  components: {
    DtTinymce
  },
  props: ['activeData']
}
</script>

<style lang="scss" scoped></style>
